export class ReportCallSite {
  constructor(
    private readonly id: number,
    private readonly covered: boolean | null,
    private readonly className: string | null,
    private readonly method: string,
    private readonly file: string | null,
    private readonly line: number,
    private readonly calledClass: string | null,
    private readonly calledMethod: string | null
  ) {}

  getId() {
    return this.id;
  }

  getCovered() {
    return this.covered;
  }

  getClass() {
    return this.className;
  }

  getMethod() {
    return this.method;
  }

  getFile() {
    return this.file;
  }

  getLine() {
    return this.line;
  }

  getCalledClass() {
    return this.calledClass;
  }

  getCalledMethod() {
    return this.calledMethod;
  }

  getCallingClassMethod(): string {
    return [this.getClass(), this.getMethod()].filter((v) => v).join('.');
  }

  getCalledClassMethod(): string {
    return [this.getCalledClass(), this.getCalledMethod()].filter((v) => v).join('.');
  }

  getLocation(): string {
    return this.getFile() ? this.getFile() + ': ' + this.getLine() : String(this.getLine());
  }
}
